<template>
  <div class="hand-punish-page">
    <van-list v-model="loading" :finished="finished" finished-text="— 暂无更多数据 —" @load>
      <div class="d_jump item" v-for="(item, index) in BrandAcountList" :key="index">
        <div class="dis bottom-line">
          <div class="img">
            <img
              :src="item.brandLogo?item.brandLogo:'https://j.weizan.cn/youxiang/images/stage_img.png'"
            />
            <span class="brand-name two-nowrap">{{item.brandName}}</span>
          </div>
          <div class="btn">
            <van-button size="small" type="info" round @click="onReward(item)">奖励</van-button>
            <van-button size="small" class="warm" round @click="onPunish(item)">惩罚</van-button>
          </div>
        </div>

        <div class="curr">
          <span>保证金金额: ￥{{item.penaltyAvailableMoney}}</span>
          <span>积分: {{item.availableScore}}</span>
        </div>
      </div>
    </van-list>

    <van-popup v-model="reward" position="bottom" class="pupop">
      <div class="title bottom-line">奖励</div>
      <div class="pupop-item bottom-line">
        <div class="reason">奖励原因</div>
        <van-field v-model="remark" maxlength="200" />
      </div>
      <div class="pupop-item bottom-line">
        <div class="reason">奖励积分</div>
        <van-field type="number" v-model.number="score" maxlength="5" />
      </div>
      <div class="sure-btn">
        <van-button type="info" @click="saveReward">确认奖励</van-button>
      </div>
    </van-popup>

    <van-popup v-model="punish" position="bottom" class="pupop">
      <div class="title bottom-line">惩罚</div>
      <div class="pupop-item bottom-line">
        <div class="reason">惩罚原因</div>
        <van-field v-model="remark" maxlength="200" />
      </div>
      <div class="pupop-item bottom-line">
        <div class="reason">惩罚积分</div>
        <van-field type="number" v-model.number="score" maxlength="5" />
      </div>
      <div class="pupop-item bottom-line">
        <div class="reason">惩罚现金</div>
        <van-field type="number" v-model.number="promise_fee" maxlength="5" />
      </div>

      <div class="sure-btn">
        <van-button type="info" @click="savePunish">确认惩罚</van-button>
      </div>
    </van-popup>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      page: 1,
      loading: false,
      finished: true,
      brands: [],
      score: null,
      promise_fee: "",
      remark: "",
      brand_id: null,
      type: null,
      reward: false,
      punish: false,
      BrandAcountList: [],
      isClick: false,
    };
  },
  created() {
    // this.getUser();
    this.getQueryBrandAcountList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    async getQueryBrandAcountList() {
      let res = await this.$http.post("/v1/taskmanage/query_brand_acount_list");
      console.log(res);
      if (res.data && res.code == 0) {
        this.BrandAcountList = res.data;
      }
    },
    // 奖励品牌
    async saveReward() {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      if (this.score != "" && this.score < 0) {
        this.$toast("奖励积分不可小于0！");
        this.isClick = false;
        return;
      }
      var actId = localStorage.getItem("act_id");
      let act = {
        actId: actId,
        adminId: 1, //需要获取操作员Id
        amount: 0,
        brandId: this.brand_id,
        remark: this.remark,
        score: this.score,
      };
      let res = await this.$http.post(
        `/v1/taskmanage/reward_punish_brand_score`,
        act
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
        this.getQueryBrandAcountList();
        this.reward = false;
      } else {
        this.$toast(res.msg);
        this.isClick = false;
      }
    },
    // 惩罚品牌
    async savePunish() {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      if (this.score != "" && this.score < 0) {
        this.$toast("惩罚积分不可小于0！");
        this.isClick = false;
        return;
      }
      if (this.promise_fee != "" && this.promise_fee < 0) {
        this.$toast("惩罚现金不可小于0！");
        this.isClick = false;
        return;
      }
      if (!this.score && !this.promise_fee) {
        this.$toast("请填写惩罚积分或惩罚现金");
        this.isClick = false;
        return;
      }
      var actId = localStorage.getItem("act_id");
      let act = {
        actId: actId,
        adminId: 1, //需要获取操作员Id
        amount: this.promise_fee,
        brandId: this.brand_id,
        remark: this.remark,
        score: this.score,
      };
      let res = await this.$http.post(`/v1/taskmanage/punish_brand`, act);
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
        this.getQueryBrandAcountList();
        this.punish = false;
      } else {
        this.$toast(res.msg);
        this.isClick = false;
      }
    },
    /**
     * 获取品牌
     */
    getBrands() {
      return;
      const json = {
        activity_id: this.activity.id,
        page: this.page,
      };
      this.loading = true;
      this.$fn.get("brands", json, (res) => {
        this.loading = false;
        if (res.status !== "success") {
          return;
        }
        this.brands = this.brands.concat(res.data);
        if (res.data.length > 0) {
          this.page++;
        }
        if (res.meta.current_page === res.meta.last_page) {
          this.finished = true;
        }
      });
    },
    /**
     * 奖励按钮
     * @param value
     */
    onReward(value) {
      this.brand_id = value.brandId;
      this.remark = "";
      this.score = "";
      this.reward = !this.reward;
      this.isClick = false;
    },
    /**
     * 惩罚按钮
     * @param value
     */
    onPunish(value) {
      this.brand_id = value.brandId;
      this.remark = "";
      this.score = 0;
      this.promise_fee = 0;
      this.punish = !this.punish;
      this.isClick = false;
    },
    /**
     * 提交奖励/惩罚内容
     * @param type
     */
    onHand(type) {
      if (!this.validata()) {
        return;
      }
      const json = {
        type: type,
        brand_id: this.brand_id,
        score: this.score,
        promise_fee: this.promise_fee,
        remark: this.remark,
      };
      this.$fn.showLoading();
      this.$fn.post("brands/reward_or_punish", json, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.fail(res.msg, () => {
            this.score = null;
            this.promise_fee = null;
            this.remark = "";
            this.brand_id = null;
            this.type = null;
          });
        }
        this.$fn.success(res.msg, () => {
          this.score = null;
          this.promise_fee = null;
          this.remark = "";
          this.brand_id = null;
          this.type = null;
          this.reward = false;
          this.punish = false;
          this.loading = false;
          this.finished = false;
          this.brands = [];
          this.page = 1;
        });
      });
    },
    validata() {
      if (!this.remark && this.type === 1) {
        return this.$fn.toast("请输入奖励原因");
      }
      if (!this.score && this.type === 1) {
        return this.$fn.toast("请输入奖励积分");
      }
      if (!this.remark && this.type === 2) {
        return this.$fn.toast("请输入惩罚原因");
      }
      if (!this.score && this.type === 2) {
        return this.$fn.toast("请输入惩罚积分");
      }
      if (!this.promise_fee && this.type === 2) {
        return this.$fn.toast("请输入惩罚现金");
      }
      return true;
    },
    /**
     * 获取用户信息
     */
    getUser() {
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.user = res.data;
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.kpi_user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        this.$fn.commonShare(this.activity, this.user, this.kpi_user);
      });
    },
  },
};
</script>

<style lang="less">
.hand-punish-page {
  padding-bottom: 20px;
  .ul {
    height: 100%;
    position: fixed;
    right: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    li {
      padding: 2px 5px;
      color: #999999;
      font-size: 12px;
    }
  }
  .d_jump {
    margin-bottom: 10px;
    font-size: 12px;
    .letter {
      padding: 3px 10px;
    }
  }

  .item {
    background-color: #ffffff;
    padding: 10px;
    .dis {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      padding-bottom: 10px;
      .img {
        display: flex;
        align-items: center;
        width: 60%;
        img {
          width: 60px;
          max-width: 60px;
          min-width: 60px;
          height: 60px;
          margin-right: 5px;
        }
        .brand-name {
          font-weight: bold;
        }
      }
      .btn {
        display: flex;
        margin-right: 5px;
        .warm {
          background-color: #f58022;
          color: #ffffff;
        }
        .van-button--small {
          height: 24px;
          line-height: 22px;
          margin-right: 5px;
        }
      }
    }
    .curr {
      padding: 10px 20px 0 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        width: 50%;
        text-align: left;
      }
    }
  }

  .pupop {
    .title {
      font-size: 15px;
      font-weight: bold;
      text-align: center;
      line-height: 44px;
      .van-icon-cross {
        position: absolute;
        right: 10px;
        font-size: 20px;
      }
    }
    .pupop-item {
      /*将输入框并列*/
      display: flex;
      align-items: center;
      justify-content: space-between;
      .van-cell {
        width: 50%;
      }
      .van-cell__value {
        border: 1px solid #dcdcdc;
        border-radius: 4px;
      }
      .reason {
        padding-left: 15px;
      }
      .van-field__control {
        padding: 0 5px;
      }
    }
    .sure-btn {
      width: 100%;
      text-align: center;
      margin: 50px 0 30px;
      .van-button {
        width: 94%;
      }
    }
  }
}
</style>
